import LanguageSwitcherComponent from "./languageSwitcherComponent";

export default LanguageSwitcherComponent;
